import { Status } from '@/models/Status';

export enum UserRole {
  SystemAdmin = 'SYSTEM_ADMIN',
  RetailerAdmin = 'RETAILER_ADMIN',
  StoreManager = 'STORE_MANAGER',
  SupplierAdmin = 'SUPPLIER_ADMIN',
  Unknown = 'UNKNOWN',
}

export const allUserRoles = [
  UserRole.SystemAdmin,
  UserRole.RetailerAdmin,
  UserRole.StoreManager,
  UserRole.SupplierAdmin,
];

export function parseUserRole(roleStr: string): UserRole {
  switch (roleStr.toUpperCase()) {
    case 'SYSTEM_ADMIN':
      return UserRole.SystemAdmin;
    case 'RETAILER_ADMIN':
      return UserRole.RetailerAdmin;
    case 'STORE_MANAGER':
      return UserRole.StoreManager;
    case 'SUPPLIER_ADMIN':
      return UserRole.SupplierAdmin;
    default:
      return UserRole.Unknown;
  }
}

export function formatUserRole(role: UserRole | string): string {
  switch (role) {
    case UserRole.SystemAdmin:
      return 'System Admin';
    case UserRole.RetailerAdmin:
      return 'Retailer Admin';
    case UserRole.StoreManager:
      return 'Store Manager';
    case UserRole.SupplierAdmin:
      return 'Supplier Admin';
    case UserRole.Unknown:
    default:
      return 'Unknown';
  }
}

export function formatUserRoleForAdmin(role: UserRole | string): string {
  switch (role) {
    case UserRole.SystemAdmin:
      return 'System Admin';
    case UserRole.RetailerAdmin:
      return 'Retailer Admin';
    case UserRole.StoreManager:
      return 'Store Manager';
    case UserRole.SupplierAdmin:
      return 'Supplier Admin';
    case UserRole.Unknown:
    default:
      return 'Unknown';
  }
}

export const isSupplier = (userRole: UserRole): boolean => userRole === UserRole.SupplierAdmin;
export const isAdmin = (userRole: UserRole): boolean => userRole === UserRole.SystemAdmin;
export const isCustomer = (userRole: UserRole): boolean => userRole === UserRole.RetailerAdmin;
export const isRetailer = (userRole: UserRole): boolean => userRole === UserRole.StoreManager;

export interface User {
  id: string;
  username: string;
  password?: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  role: UserRole;
  mobileCountryCode?: string;
  mobileNumber?: string;
  currencyCode: string;
  languageCode: string;
  timezone: string;
  status: Status;
  settings?: UserSettings;
  organizationId?: string;
  retailerId?: string;
  storeId?: string;
  supplierId?: string;
  createdAt?: Date;
  lastSignInAt?: Date;
}

export interface Users {
  items: User[];
  totalCount?: number;
  estimatedTotalCount?: number;
}

export interface NotificationSettings {
  email: boolean;
  sms: boolean;
  orders: boolean;
  promotions: boolean;
}

export interface UserSettings {
  notifications?: NotificationSettings;
}
